import { render, staticRenderFns } from "./EmployerAdd.vue?vue&type=template&id=768c28c4&"
import script from "./EmployerAdd.vue?vue&type=script&lang=js&"
export * from "./EmployerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports